import { WorklistValues } from "features/WorklistTools/shared/interfaces";
import { Alert, AlertType } from "shared-components/toast";
import { ExternalThawToolActions, WorklistValuesState } from "../../state";

export const addDestinationWellMapping = (
  dispatch: (action: { type: string; payload: any }) => void,
  sourceIntIndex: number,
  wellMapping: WorklistValues[],
  //destPlateInfo: DestPlateInfoState[],
  worklistValues: WorklistValuesState
  //destSelection: any,
  // isStamping: boolean
) => {
  if (singleChannelContainsSameIntToSameDestWell(wellMapping, worklistValues)) {
    Alert({
      type: AlertType.ERROR,
      message:
        "Cannot seed same intermediate well to the same destination well",
    });
    return;
  }
  dispatch(
    ExternalThawToolActions.INT_TO_DEST_ADDED({
      index: sourceIntIndex,
      selections: wellMapping,
    })
  );
};

const singleChannelContainsSameIntToSameDestWell = (
  wellMapping: WorklistValues[],
  worklistValues: WorklistValuesState
) => {
  const intPlateIndex = wellMapping[0].sourcePlateIndex;
  const destPlateIndex = wellMapping[0].destPlateIndex;

  const intToDest = worklistValues.int1ToDest;
  for (const well of wellMapping) {
    const intToDestAlreadyExists = Boolean(
      intToDest?.find(
        (e) =>
          e.sourcePlateIndex === intPlateIndex &&
          e.destPlateIndex === destPlateIndex &&
          e.sourceWellId === well.sourceWellId &&
          e.destWellId === well.destWellId
      )
    );
    if (intToDestAlreadyExists) return true;
  }

  return false;
};
